import React from 'react';
import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { parseContent } from 'client/data/cms/content';
import { legacyPageUpdate } from 'client/actions/legacy-page';
import { setCriticalCss } from 'client/actions/critical-css';
import { updateVehicle } from 'client/actions/vehicle';
import { handle404Error } from 'site-modules/shared/utils/errors';
import {
  getTopRatedArticleContentPath,
  getTopRatedThemeContentPath,
} from 'site-modules/shared/utils/top-rated/content-path';
import { getTopRatedArticleSeoObject } from 'site-modules/editorial/pages/top-rated/seo';
import { EdmundsTopRatedDecorator } from 'site-modules/shared/pages/decorators/edmunds-top-rated';
import { TOP_RATED } from 'site-modules/shared/constants';
import { decoratorParams } from 'site-modules/shared/pages/decorators/decorator-params';
import { getSectValues } from 'site-modules/shared/utils/top-rated/get-sect-values';

function getPageName(slug, year, prefix, isDefaultYear) {
  const pageParts = [];
  pageParts.push(prefix || TOP_RATED);
  pageParts.push(`${slug}_article`);
  if (!isDefaultYear) {
    pageParts.push(year);
  }
  return pageParts.join('_');
}

export const getPageOptions = ({ type, year, isDefaultYear, pageTemplate: PageTemplate, chunkName }) => ({
  name: getPageName(type, year, null, isDefaultYear),
  category: 'top_rated',
  chunkName,
  adsCustomTargeting: {
    sect1: getSectValues(year, type),
    sect2: getSectValues(year, type),
  },
  seo: (state, props) => {
    const contentPath = getTopRatedArticleContentPath(type, year);
    const content = parseContent(state.cms.content[contentPath]);

    return getTopRatedArticleSeoObject(content, props.location.pathname);
  },
  preload: store => {
    const preloader = new ModelPreloader(store);
    const articlePath = getTopRatedArticleContentPath(type, year);
    const themePath = getTopRatedThemeContentPath(year);
    preloader.resolve(`content["${articlePath}"]`, CmsModel);
    preloader.resolve(`content["${themePath}"]`, CmsModel);
    return preloader.load().then(modelState => {
      const article = modelState.get(`content["${articlePath}"]`, CmsModel);
      if (!(article && article.id)) {
        throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
      }
      const edwPrefix = get(article, 'contentMetadata.edwPrefix');
      if (edwPrefix) {
        store.dispatch(
          legacyPageUpdate({
            pageName: getPageName(type, year, article.contentMetadata.edwPrefix, isDefaultYear),
          })
        );
      }

      // the year is needed when it switches to another by cdDate
      store.dispatch(setCriticalCss({ year }));

      store.dispatch(updateVehicle({ type: { niceName: type } }));

      return preloader.load();
    });
  },
  decorator: decoratorParams(EdmundsTopRatedDecorator, { year, isDefaultYear }),
  component: props => <PageTemplate {...props} type={type} year={year} isDefaultYear={isDefaultYear} />,
  options: {
    hasVehicleContext: true,
  },
});
